import type { NivelSemaforo } from '../types'

export function nivelPorDias(dias: number): NivelSemaforo {
  if (dias <= 3) return 'rojo'
  if (dias <= 10) return 'ambar'
  return 'verde'
}

export const ESTILO_SEMAFORO: Record<
  NivelSemaforo,
  { punto: string; chip: string; barra: string; texto: string; etiqueta: string }
> = {
  rojo: {
    punto: 'bg-peligro-500',
    chip: 'bg-peligro-50 text-peligro-700 ring-1 ring-peligro-100',
    barra: 'bg-peligro-500',
    texto: 'text-peligro-600',
    etiqueta: 'Crítico',
  },
  ambar: {
    punto: 'bg-ambar-400',
    chip: 'bg-ambar-50 text-ambar-700 ring-1 ring-ambar-100',
    barra: 'bg-ambar-400',
    texto: 'text-ambar-700',
    etiqueta: 'Por vencer',
  },
  verde: {
    punto: 'bg-exito-500',
    chip: 'bg-exito-50 text-exito-700 ring-1 ring-exito-100',
    barra: 'bg-exito-500',
    texto: 'text-exito-700',
    etiqueta: 'En tiempo',
  },
}
